import React from 'react';
import { ArrowRight } from 'lucide-react';
import StreakSummary from './StreakSummary';

export default function StreakCompletionStep({ streak, onContinue }) {
  return (
    <div className="streak-completion-step">
      <StreakSummary streak={streak} celebration />
      <button
        type="button"
        className="button button-primary streak-completion-step__continue"
        onClick={onContinue}
      >
        Continue
        <ArrowRight size={20} />
      </button>
    </div>
  );
}
